<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cell-click="chooseRow"
            :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="seeDetail">查看</vxe-button>
      </template>
    </x-grid>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

const fac = XGrid.factory;

//列表接口
const url = api.workflow.WORK_FLOW_FINISH;

//主键
const rowId = 'id';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("id", "id", 100),
  fac.makeColumn("deploymentId", "部署ID", 140),
  fac.makeColumn("processDefinitionName", "流程名称", 160),
  fac.makeColumn("processDefinitionKey", "流程标识", 160),
  fac.makeColumn("startTime", "开始时间", 160),
  fac.makeColumn("endTime", "结束时间", 160),
  fac.makeColumn("durationInMillis", "用时", 160),
  fac.makeColumn("diagramResourceName", "流程图片", 160),
]

let formConfig = fac.makeFormConfig(columns, [
  {field: 'id'},
  {field: 'processDefinitionKey'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  delData: false,
  import: false,
  export: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  components: {},
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,

    }
  },
  methods: {
    seeDetail() {
      console.log(1)
    },
  }
}
</script>

<style scoped>
</style>